import { useGetNotes } from 'src/components/Tickets/hooks/useGetNotes';
import { EmptyNotes } from './EmptyNotes/EmptyNotes';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';
import { useState } from 'react';
import { NoteContent } from '../../../desktop/TicketDetailsPopup/Notes/Note';
import {
  AttachIcon,
  InputWrapper,
  NoteInput,
  NotesButtonWrapper,
  NotesInputWrapper,
  NotesWrapper,
  SendIcon,
} from './NotesTab.styled';
import { Button } from '@fluentui/react-components';
import { useCreateNote } from 'src/components/Tickets/hooks/useCreateNote';
import { StatusChangedNote } from '../../../desktop/TicketDetailsPopup/Notes/StatusChangedNote';
import { AttachPopup } from './AttachPopup/AttachPopup';
import { FileAttachment } from '../../../desktop/TicketDetailsPopup/FileAttachment/FileAttachment';
import { ErrorMessage } from '../../../desktop/TicketDetailsPopup/TicketDetailsNotesSection/ErrorMessage/ErrorMessage';
import { LoadingSpinner } from 'src/components/common/LoadingSpinner/LoadingSpinner';
import { Alert } from 'src/components/common/AlertMessage/AlertMessage';

export const NotesTab = () => {
  const {
    viewTicketId,
    toggleTicketDetails,
    ticketOwner,
    showErrorMessage,
    errorMessage,
    handleShowErrorMessage,
    showInputField,
    toggleInputField,
  } = useServiceDeskContext();
  const {
    createNote,
    hideAlert,
    requestStatusAppearance,
    requestStatusMessage,
  } = useCreateNote();
  const [newNoteSubmitted, setNewNoteSubmitted] = useState<boolean>(false);
  const { notesData, loadingNotes, getNotesData } = useGetNotes(
    viewTicketId,
    newNoteSubmitted
  );
  const [noteText, setNoteText] = useState<string>('');
  const {
    toggleAttachOverlay,
    openAttachOverlay,
    uploadedFile,
    fileUploaded,
    handleUploadedFile,
  } = useServiceDeskContext();

  const handleSubmit = async () => {
    if (noteText.trim().length > 4 || uploadedFile) {
      try {
        await createNote(viewTicketId, noteText, uploadedFile);
        setNewNoteSubmitted(true);
        setNoteText('');
        handleUploadedFile(null, false);
        await getNotesData();
      } catch (error) {
        console.error(error);
      }
    } else {
      handleShowErrorMessage(
        true,
        'Note text should be at least 5 characters long.'
      );
    }
  };
  const handleTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNoteText(event.target.value);

    if (event.target.value.length > 4) {
      handleShowErrorMessage(false, '');
    }
  };

  const handleBackToTicketList = () => {
    toggleTicketDetails('', '', false);
    if (!notesData || notesData.length === 0) {
      toggleInputField(false);
    }
    handleShowErrorMessage(false, '');
  };

  if (loadingNotes) {
    return (
      <NotesWrapper>
        <LoadingSpinner />
      </NotesWrapper>
    );
  }

  return (
    <>
      {openAttachOverlay && <AttachPopup />}
      {requestStatusMessage && (
        <Alert
          requestStatusAppearance={requestStatusAppearance}
          requestStatusMessage={requestStatusMessage}
          showCloseButton={true}
          overlay={true}
          handleClose={hideAlert}
        />
      )}
      {((notesData && notesData.length != 0) || showInputField) && (
        <NotesWrapper>
          {notesData &&
            notesData.map((currNote) => {
              if (
                currNote &&
                currNote?.notetext &&
                currNote?.notetext.startsWith('Status Reason changed to:')
              ) {
                const newStatus = currNote?.notetext.substring(
                  'Status Reason changed to:'.length
                );
                return (
                  <StatusChangedNote
                    key={currNote?.annotationid}
                    note={currNote}
                    newStatus={newStatus}
                    ticketOwner={ticketOwner}
                  />
                );
              } else {
                return (
                  <NoteContent key={currNote?.annotationid} note={currNote} />
                );
              }
            })}
        </NotesWrapper>
      )}
      {showInputField && (
        <InputWrapper>
          <AttachIcon onClick={() => toggleAttachOverlay(true)} />
          <NotesInputWrapper>
            <NoteInput
              placeholder="Type a note"
              value={noteText}
              onChange={handleTextChange}
            />
            {fileUploaded && (
              <FileAttachment
                fileName={uploadedFile.name}
                onClose={() => handleUploadedFile(null, false)}
              />
            )}
          </NotesInputWrapper>
          <SendIcon onClick={handleSubmit} />
        </InputWrapper>
      )}
      {showErrorMessage && <ErrorMessage message={errorMessage} />}
      {showInputField && (
        <NotesButtonWrapper>
          <Button onClick={handleBackToTicketList}>Back to Ticket list</Button>
        </NotesButtonWrapper>
      )}
      {(!notesData || notesData.length == 0) && !showInputField && (
        <EmptyNotes />
      )}
    </>
  );
};
